module.exports = __webpack_public_path__ + "img/logo.b2a7c864.png";